import { Stepper } from 'avo-ui'

export const ProductImport = ({ steps, stepContent, activeStep }) => {
    return (
        <div className={'flex flex-col items-center space-y-8 px-9 py-4'}>
            <Stepper steps={steps} activeStep={activeStep} />
            {stepContent[activeStep - 1]}
        </div>
    )
}
